import React, { useState, useRef } from 'react';
import { Row, Col, Button, Input, Modal } from 'antd';
import GetNewAppVersion from '../../../../static/appVersion/android/index.text'
import GetNewAppVersionXML from '../../../../static/appVersion/android/android_dashboard_show_new_version_dialog.text'
import iHealthSDKCheckVersionTool1 from '../../../../static/appVersion/ios/iHealthSDKCheckVersionTool1.text'
import iHealthSDKCheckVersionTool2 from '../../../../static/appVersion/ios/iHealthSDKCheckVersionTool2.text'

const IntegrationPage = (props) => {
    const [divHeight, setDivHeight] = useState(0);

    React.useEffect(() => {

    }, [])

    function downloadAndroid() {
        fetch(GetNewAppVersion)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "GetNewAppVersion.java");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

        fetch(GetNewAppVersionXML)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'xml'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "android_dashboard_show_new_version_dialog.xml");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

    }
    function downloadIOS() {
        fetch(iHealthSDKCheckVersionTool1)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "iHealthSDKCheckVersionTool.h");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

            fetch(iHealthSDKCheckVersionTool2)
            .then(function (response) {
                return response.text();
            }).then(function (data) {
                const link = document.createElement('a');
                link.setAttribute('href', `data:text/${'java'};charset=utf-8,${encodeURIComponent(data)}`);
                link.setAttribute('download', "iHealthSDKCheckVersionTool.m");
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })

    }
    return (
        <div style={{ marginLeft: '30px', marginTop: '30px', display: props.isIntegration }}>
            <Row>
                <Col style={{ width: '150px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>新版本检测更新：</Col>
                <Col style={{  fontSize: '18px' ,background:'#fff', borderRadius: '5px',padding:'10px'}}>
                    <Row style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', }}>
                        <div style={Styles.describe}> Android模块,下载附件导入项目</div>
                        <Button className="btn" style={{ marginLeft: '10px', fontSize: '16px', padding: '0px', color: '#FF5300', border: 'none' }}
                            onClick={() => downloadAndroid()} type="text">下载附件</Button>
                    </Row>
                    <div style={Styles.describe2}> {"调用方式：GetNewAppVersion.check(getActivity(),\""+props.projectName+"\");"}</div>
                    <Row style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', }}>
                        <div style={Styles.describe}> iOS模块,下载附件导入项目</div>
                        <Button className="btn" style={{ marginLeft: '10px', fontSize: '16px', padding: '0px', color: '#FF5300', border: 'none' }}
                            onClick={() => downloadIOS()} type="text">下载附件</Button>
                    </Row>
                    <div style={Styles.describe2}> {"checkHaveNewVersion:(NSString*)(\""+props.projectName+"\");"}</div>
                    
                </Col>
            </Row>
        </div>
    )

}
const Styles = {
    describe: {
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.55)',
    }, describe2: {
        fontSize: '16px',
        color: 'rgba(0, 0, 0, 0.55)',
        marginLeft: '20px'
    },
}
export default IntegrationPage